<template>
    <div name="toast" class="toast">
        <span>공감해 주셔서 감사합니다!</span>
        <img @click="close" style="width: 22px;cursor: pointer;" src="../../../assets/close_white.png" />
    </div>
</template>

<script>
export default {
    name: 'toast',
    mounted: function()
    {
        setTimeout(() => {
            this.close();
        }, 1000); // 2000ms = 2초
    },
    methods: {
        close: function()
        {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
    .toast {
        display: flex;
        width: 100%;
        max-width: 335px;
        height: 52px;
        padding: 8px 8px 8px 16px;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        border-radius: 6px;
        background: #6B7684;
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
        position: fixed;
        top: 76px;
        left: 50%;
        transform: translate(-50%, 0);
        z-index: 5;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/m_uncomfortable/Toast.vue